// extracted by css-extract-rspack-plugin
export default {"root":"jJnjMN","content":"C3UFLT"};